<template>
  <div v-if="state.title">
    <HeroArticle v-bind="state" :show-share-button="false" variant="narrow" />
    <Grid variant="detail">
      <Alinea v-if="state.blocks" :blocks="state.blocks.blocks" />
      <TeaserGroupLoadMoreGrid
        title="Bijdragen"
        :filter="state.filter"
        component="list"
        :show-intro="false"
      />
    </Grid>
  </div>
</template>

<script setup lang="ts">
import usePageStore from '~/stores/page';
import useCollectionInstance from '~/composables/useCollectionInstance';
import type { ICmsAuthors } from '~~/types/_cms-types';
import type { ITextBlocks } from '~~/types/local_types';
import useCheckRedirect from '~/composables/useCheckRedirect';

const pageStore = usePageStore();

pageStore.setCurrentPage(undefined);

const pageData = (await useCollectionInstance('authors')) as ICmsAuthors;

if (!pageData) {
  throw createError({ statusCode: 404, statusMessage: 'Auteur niet gevonden' });
}

const state = reactive({
  ...pageData,
  blocks: pageData.biography as ITextBlocks,
  heroImage: pageData.image,
  filter: { authors: { authors_id: { id: { _eq: pageData.id } } } },
});

usePageSeo({
  pageTitle: pageData.title,
  pageDescriptionBlocks: (pageData.biography as ITextBlocks)?.blocks,
  pageImage: pageData.image,
  section: 'Biografieen',
});

await useCheckRedirect(pageData.slug, 'biografieen');

if (import.meta.client) {
  sendAnalytics({ prefix: 'biografieen', slug: pageData.slug });
}
</script>

<style scoped lang="postcss"></style>
